import { Directive } from '@angular/core';
import { CdkHeaderCellDef } from '@angular/cdk/table';

@Directive({
  selector: '[mcraiHeaderCellDef]',
  providers: [{ provide: CdkHeaderCellDef, useExisting: HeaderCellDefDirective }]
})
export class HeaderCellDefDirective extends CdkHeaderCellDef { }
